<template>
  <div id='canvas-wrapper'>
  </div>
</template>

<script>
import json from '../assets/particles.json'
export default {
  name: 'Background',
  mounted () {
    /* eslint-disable */
    require('particles.js')
    particlesJS("canvas-wrapper", json)
  }
}
</script>

<style>
.particles-js-canvas-el {
  top: 0%;
  left: 0%;
  position: fixed;
  z-index: 0;
}
</style>

<style scoped>
#canvas-wrapper {
  position: fixed;
  top: 0%;
  left: 0%;
  overflow: auto;
  width: 100vw;
  height: 100vh;
  z-index: -1;
  /* background: linear-gradient(0deg, #763c26, rgb(19, 64, 127));
   */
  background: linear-gradient(0deg, #61251d, rgb(0, 46, 111));
}

</style>